import { differenceInCalendarDays, isMatch, isPast, isToday, parse } from 'date-fns';

const validationSearchParams = (obj) => {
  console.log(obj);
  const tempError = [];
  console.log(obj.checkIn);
  if (!isMatch(unescape(obj.checkIn), 'MM/dd/yyyy')) {
    tempError.push('Check In date should be in mm/dd/yyyy format. For example 07/22/2025');
  }
  if (!isMatch(unescape(obj.checkOut), 'MM/dd/yyyy')) {
    tempError.push('Check Out date should be in mm/dd/yyyy format. For example 07/22/2025');
  }
  const checkInDate = parse(obj.checkIn, 'MM/dd/yyyy', new Date());
  const checkOutDate = parse(obj.checkOut, 'MM/dd/yyyy', new Date());
  if (Math.abs(differenceInCalendarDays(checkInDate, checkOutDate)) > 21) {
    tempError.push('There can be a maximum of 21 days between Check In and Check Out dates.');
  }

  if (!isToday(checkInDate) && isPast(checkInDate)) {
    tempError.push('Check In date must not be older than today.');
  }

  if (+obj.rooms < 1) {
    tempError.push('You must select at least one room.');
  }

  if (+obj.adults < 1) {
    tempError.push('You must select at least one guest.');
  }

  if (!(obj.latitude || obj.longitude)) {
    tempError.push('You need to choose the city or region where you will stay.');
  }
  return tempError;
};

// eslint-disable-next-line import/prefer-default-export
export { validationSearchParams };
